import { detectAppName } from 'helpers/detectAppName'

import ayahpathLogo from 'assets/images/ayah-path-logo.png'
import blessedpathLogo from 'assets/images/blessed-path-logo.png'
import karmapathLogo from 'assets/images/karma-path-logo.png'

import { APP_OUTER_LINKS, AppName, HeaderTitle } from 'root-constants'
import { TAppName, TAppNameFlags } from 'root-types'

const BLESSEDPATH_SUPPORT_MAIL = 'support@blessedpaths.com'
const AYAHPATH_SUPPORT_MAIL = 'support@ayahpath.com'
const KARMAPATH_SUPPORT_MAIL = 'support@karmapaths.com'
const BLESSEDPATH_MANAGE_SUBSCRIPTION_LINK =
  'https://account.blessedpaths.com/login'
const AYAHPATH_MANAGE_SUBSCRIPTION_LINK = 'https://account.ayahpath.com/login'
const KARMAPATH_MANAGE_SUBSCRIPTION_LINK =
  'https://account.karmapaths.com/login'

export const LEARNWORLDS_DEEP_LINK_BASE = `${window.location.origin}/landing/v2/leads/learnworlds/redirect?token=`

export const AppConfigMap = {
  [AppName.blessedPath]: {
    displayName: HeaderTitle.blessedPath,
    domains: ['blessedpath'],
    supportMail: BLESSEDPATH_SUPPORT_MAIL,
    supportLink: `mailto: ${BLESSEDPATH_SUPPORT_MAIL}`,
    manageSubscriptionLink: BLESSEDPATH_MANAGE_SUBSCRIPTION_LINK,
    appLink: 'https://quiz.blessedpaths.com',
    learnworldsCourseLink: 'https://blessedpath-course.learnworlds.com',
    outerAppBase: APP_OUTER_LINKS[AppName.blessedPath],
    logoUrl: blessedpathLogo,
    metaDescription:
      'BlessedPath is an ultimate app for daily Bible reading and spiritual growth. Take God’s Word with you wherever you go.',
  },
  [AppName.ayahPath]: {
    displayName: HeaderTitle.ayahPath,
    domains: ['ayahpath', 'theayahpath', 'ayah-path'],
    supportMail: AYAHPATH_SUPPORT_MAIL,
    supportLink: `mailto: ${AYAHPATH_SUPPORT_MAIL}`,
    manageSubscriptionLink: AYAHPATH_MANAGE_SUBSCRIPTION_LINK,
    appLink: 'https://quiz.ayahpath.com',
    learnworldsCourseLink: 'https://ayahpath.learnworlds.com',
    outerAppBase: APP_OUTER_LINKS[AppName.ayahPath],
    logoUrl: ayahpathLogo,
    metaDescription:
      'AyahPath is an ultimate app for daily Quran reading and spiritual growth. Take Allah’s Word with you wherever you go.',
  },
  [AppName.karmaPath]: {
    displayName: HeaderTitle.karmaPath,
    domains: [
      'karmapath',
      'karmapaths',
      'karma-path',
      'mykarmapath',
      'duomokarma',
    ],
    supportMail: KARMAPATH_SUPPORT_MAIL,
    supportLink: `mailto: ${KARMAPATH_SUPPORT_MAIL}`,
    manageSubscriptionLink: KARMAPATH_MANAGE_SUBSCRIPTION_LINK,
    appLink: 'https://quiz.karmapaths.com',
    learnworldsCourseLink: 'https://karmapath.learnworlds.com',
    outerAppBase: APP_OUTER_LINKS[AppName.karmaPath],
    logoUrl: karmapathLogo,
    metaDescription:
      'KarmaPath is an ultimate app for daily Quran reading and spiritual growth. Take Spiritually World with you wherever you go.',
  },
} as const satisfies Record<
  TAppName,
  {
    displayName: string
    metaDescription: string
    domains: readonly string[]
    logoUrl: string
    supportMail: string
    supportLink: string
    manageSubscriptionLink: string
    appLink: string
    learnworldsCourseLink: string
    outerAppBase?: string
  }
>

export const APP_NAME = detectAppName(AppConfigMap)

export const getIsAppName = (): TAppNameFlags => ({
  isBlessedPathDomain: APP_NAME === AppName.blessedPath,
  isAyahPathDomain: APP_NAME === AppName.ayahPath,
  isKarmaPathDomain: APP_NAME === AppName.karmaPath,
})
